import {
  FETCH_BOOKING_DISCOUNT,
  FETCH_BOOKING__DISCOUNT_SUCCESS,
  FETCH_BOOKING__DISCOUNT_FAILED,
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { get, onValue } from "firebase/database";

const parseAmount = (value) => {
  const amount = parseFloat(value);
  return isNaN(amount) ? 0 : amount;
};

const firstPresent = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const getAcceptedOfferType = (booking) => booking && booking.acceptedOfferType ? booking.acceptedOfferType : (booking && booking.acceptedFleetOffer ? "fleet" : (booking && (booking.acceptedDriverOffer || booking.selectedBid) ? "driver" : "legacy"));

const getGrossBidAmount = (booking) => {
  const offerType = getAcceptedOfferType(booking);
  if (offerType === "fleet") {
    const offer = booking.acceptedFleetOffer || {};
    return parseAmount(firstPresent(booking.fleetAdminEarningGrossAmount, offer.amount, offer.bidAmount));
  }
  if (offerType === "driver") {
    const offer = booking.acceptedDriverOffer || booking.selectedBid || {};
    return parseAmount(firstPresent(booking.driverEarningGrossAmount, offer.trip_cost, offer.amount, booking.trip_cost));
  }
  return parseAmount(booking && booking.trip_cost);
};

const getCommissionAmount = (booking) => parseAmount(firstPresent(
  booking && booking.garahexCommissionAmount,
  booking && booking.fleetAdminEarningCommissionAmount,
  booking && booking.driverEarningCommissionAmount,
  booking && booking.driverAcceptanceFeeTotal,
  booking && booking.convenience_fees
));

const getNetPayeeAmount = (booking) => {
  const offerType = getAcceptedOfferType(booking);
  if (offerType === "fleet") {
    return parseAmount(firstPresent(booking.fleetAdminEarningNetAmount, booking.fleetAdminEarningAmount, Math.max(getGrossBidAmount(booking) - getCommissionAmount(booking), 0)));
  }
  if (offerType === "driver") {
    return parseAmount(firstPresent(booking.driverEarningNetAmount, booking.driverEarningAmount, Math.max(getGrossBidAmount(booking) - getCommissionAmount(booking), 0)));
  }
  return parseAmount(booking && booking.driver_share);
};

const getCommissionType = (booking) => firstPresent(
  booking && booking.commission_type,
  booking && booking.commissionType,
  booking && booking.convenience_fee_type,
  booking && booking.garahexCommissionBreakdown && booking.garahexCommissionBreakdown.type
) || "";

const getCommissionRate = (booking) => firstPresent(
  booking && booking.commission_rate,
  booking && booking.commissionRate,
  booking && booking.convenience_fee_rate,
  booking && booking.garahexCommissionBreakdown && booking.garahexCommissionBreakdown.rate
) || "";

const getCommissionPayerRole = (booking) => {
  if (booking && booking.garahexCommissionDeductedRole) return booking.garahexCommissionDeductedRole;
  const offerType = getAcceptedOfferType(booking);
  if (offerType === "fleet") return "fleetadmin";
  if (offerType === "driver") return "driver";
  return "";
};

export const fetchEarningsReport = () => async (dispatch) => {

  const {
    bookingRef,
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_BOOKING_DISCOUNT,
    payload: null
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  const decimals = settings.decimal || 2;

  onValue(bookingRef, snapshot => {
    if (snapshot.val()) {
      const mainArr = snapshot.val();
      const arr = Object.keys(mainArr).map(j => {
        const booking = mainArr[j];
        const status = booking.status;
        const isReportable = status === 'PAID' || status === 'COMPLETE' || status === 'COMPLETED' || (status === 'CANCELLED' && booking.hasOwnProperty("cancellationFee"));
        if (isReportable) {
          const grossAmount = getGrossBidAmount(booking);
          const commissionAmount = status === 'CANCELLED' ? parseAmount(booking.cancellationFee) : getCommissionAmount(booking);
          return {
            id: j,
            bookingReference: booking.reference || booking.bookingNumber || j,
            acceptedOfferType: getAcceptedOfferType(booking),
            payerRole: getCommissionPayerRole(booking),
            payerId: booking.garahexCommissionDeductedFrom || booking.acceptedFleetAdmin || booking.fleetadmin || booking.driver || "",
            grossAmount: grossAmount.toFixed(decimals),
            commissionType: getCommissionType(booking),
            commissionRate: getCommissionRate(booking),
            commissionAmount: commissionAmount.toFixed(decimals),
            netPayeeAmount: getNetPayeeAmount(booking).toFixed(decimals),
            bookingStatus: status || "",
            deductionStatus: booking.garahexCommissionDeducted ? "Deducted" : (commissionAmount > 0 ? "Pending / Not recorded" : "Not available"),
            deductedAt: booking.garahexCommissionDeductedAt || "",
            source: getAcceptedOfferType(booking) === "fleet" ? "acceptedFleetOffer" : (getAcceptedOfferType(booking) === "driver" ? "acceptedDriverOffer" : "legacy")
          };
        }
        return null;
      }).filter(Boolean);
      dispatch({
        type: FETCH_BOOKING__DISCOUNT_SUCCESS,
        payload: arr
      });

    } else {
      dispatch({
        type: FETCH_BOOKING__DISCOUNT_FAILED,
        payload: "No data available."
      });
    }
  });
};
